<template>
  <div class="dept-tips">
    <template v-if="['010405', '0110C', '0110H', '0110D', '0110E', '0110F', '0110G', '01076','012F01','012F02'].includes(item.deptCode)">
      {{ item.doctorName | nameTips }}
    </template>
    <template v-else>
      {{ item.deptCode | tips }}
    </template>
  </div>
</template>
<script>
export default {
  name: 'DeptTips',
  filters: {
    tips: (val) => {
      switch (val) {
        case '0104':
        case '010404':
        case '010403':
        case '010401':
        case '010402':
          return '本门诊每天限号5个，需另收心理专家咨询费用 195/次（不包含其他的检查费用）'
        case '01101':
        case '01104':
        case '01105':
        case '01106':
        case '01107':
        case '01108':
        case '01109':
        case '01075':
        case '0110B':
          return '本门诊需另收心理咨询费195元/次（不包括其它检查治疗费用）'
        case '01084':
          return '本门诊每次限号3人。挂号费195元/次（全自费，不含其他检查治疗费用）。建议就诊前完善好头颅CT或MRI、脑电图、心电图及血常规、生化等常规检查检验，就诊时带好所有既往病史资料。'
        default:
          return ''
      }
    },
    nameTips: (val) => {
      switch (val) {
        case '杜向东':
        case '汤臻':
        case '吴天诚':
        case '柳艳松':
        case '朱晓敏':
        case '王世锴':
        case '郭萍':
        case '张广亚':
        case '朱宏亮':
        case '朱峰':
        case '杨勇':
        case '蒋萍':
          return '另收心理专家咨询费195元/次(不含其它的检查治疗费用)'
        case '陆心传':
        case '叶刚':
        case '高炬':
        case '刘金华':
        case '蔡黎杰':
        case '黄月香':
        case '李金':
        case '刘期春':
        case '权昕':
        case '陆培芳':
        case '罗林':
        case '廉富蕊':
        case '王水兰':
        case '李哲':
        case '邵莘蓓':
        case '盖海军':
        case '王秀艳':
        case '胡金涛':
        case '刘璐璐':
        case '王丹':
        case '张子一':
        case '姜文静':
        case '付佳林':
        case '杨荣':
        case '朱安秀':
        case '高振勇':
        case '王奕':
          return '另收心理咨询费195元/次(不含其它的检查治疗费用)'
        default:
          return ''
      }
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="less" scoped>
.dept-tips {
  color: #c00;
  font-size: 14px;
  line-height: 1.2;
  margin-top: 8px;
}
</style>

